﻿import React from "react";
import { createRoot } from "react-dom/client";
import QuickSearch from "./QuickSearch.jsx";

// Mounts the quick-search popup once, outside the app layout.
if (typeof document !== "undefined" && !window.__quickSearchMounted) {
  window.__quickSearchMounted = true;
  const el = document.createElement("div");
  el.id = "quick-search-root";
  document.body.appendChild(el);
  createRoot(el).render(<QuickSearch />);
}

// keep --nav-h equal to the real navbar height
if (typeof document !== "undefined" && !window.__navHeightWatch) {
  window.__navHeightWatch = true;
  const measure = () => {
    const nav = document.querySelector(".app-navbar");
    if (nav) document.documentElement.style.setProperty("--nav-h", nav.offsetHeight + "px");
  };
  setInterval(measure, 500);
  window.addEventListener("resize", measure);
}
